












































































import firebase from "firebase";
import { Component, Vue } from "vue-property-decorator";
import SoundManagerONP from "../SoundManagerONP";
const VueProps = Vue.extend();
@Component<GameEnd>({})
export default class GameEnd extends VueProps {
  public canvas!: HTMLCanvasElement;

  public save(): void {
    SoundManagerONP.btnSound();
    firebase.analytics().setCurrentScreen("save");
    firebase.analytics().logEvent("screen_view");
    console.log("save");
    this.$emit("save");
  }
  public replay(): void {
    SoundManagerONP.btnSound();
    firebase.analytics().setCurrentScreen("replay");
    firebase.analytics().logEvent("screen_view");
    console.log("replay");
    this.$emit("replay");
  }
  private shareURL = "";

  public async shareImage(): Promise<void> {
    firebase.analytics().setCurrentScreen("share");
    firebase.analytics().logEvent("screen_view");
    if (this.shareURL == "") return;
    const shareData = {
      title: "HOLD YOUR FART!",
      text: this.shareURL,
      url: this.shareURL,
    };
    try {
      await navigator.share(shareData);
    } catch (err) {
      //alert("Sharing does not supported.");
    }
  }
  get isEn() {
    return this.$i18n.locale == "en";
  }
  public numberFormat(number: number) {
    if (this.isEn) {
      return this.formatNumber(number);
    }
    var unitWords = ["", "만", "억", "조", "경"];
    var splitUnit = 10000;
    var splitCount = unitWords.length;
    var resultArray = [];
    var resultString = "";

    for (var i = 0; i < splitCount; i++) {
      var unitResult =
        (number % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
      unitResult = Math.floor(unitResult);
      if (unitResult > 0) {
        resultArray[i] = unitResult;
      }
    }

    for (var i = 0; i < resultArray.length; i++) {
      if (!resultArray[i]) continue;
      resultString = String(resultArray[i]) + unitWords[i] + resultString;
    }

    return resultString;
  }
  public formatNumber(n: number) {
    var ranges = [
      { divider: 1e18, suffix: "E" },
      { divider: 1e15, suffix: "P" },
      { divider: 1e12, suffix: "T" },
      { divider: 1e9, suffix: "G" },
      { divider: 1e6, suffix: "M" },
      { divider: 1e3, suffix: "k" },
    ];
    for (var i = 0; i < ranges.length; i++) {
      if (n >= ranges[i].divider) {
        return (n / ranges[i].divider).toString() + ranges[i].suffix;
      }
    }
    return n.toString();
  }
  public get playedTime(): string {
    if (this.gameData.playTime < 60) {
      return this.gameData.playTime.toString() + this.$i18n.t("message.sec");
    }

    return (
      Math.round(this.gameData.playTime / 60).toString() +
      this.$i18n.t("message.min")
    );
  }
  public saveImage() {
    /*var uri = this.canvas.toDataURL("image/png").replace("image/png", "octet/stream");
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = uri;
    a.download = "nobc.png";
    a.click();
    window.URL.revokeObjectURL(uri);
    document.body.removeChild(a);*/
    //const win = window.open(uri, '_blank');
    var w: any = window.open("", "");
    w.document.title = "Screenshot";
    //w.document.body.style.backgroundColor = "red";
    var img = new Image();
    // Without 'preserveDrawingBuffer' set to true, we must render now
    //this.renderer.render(this.scene, this.camera);
    img.src = this.canvas?.toDataURL("image/png");
    w.document.body.appendChild(img);
  }
  public targetImageData: any;
  public setImage(
    data: any,
    ccNum: number,
    cc: string,
    date: string,
    frame: any,
    playedTime: number
  ) {
    this.gameData.cc = cc + " cc";
    this.gameData.ccNum = ccNum;
    this.gameData.date = date;
    this.gameData.playTime = playedTime;
    this.targetImageData = data;
    this.makeImage(data, frame);
    var i: any = this.$refs.imgg;
    i.src = this.canvas?.toDataURL("image/png");
    this.$emit("score", this);
  }

  mounted() {
    this.canvas = document.createElement("canvas");
    this.canvas.width = 700;
    this.canvas.height = 700;
    this.shareURL = "";

    document.body.ontouchstart = (eve) => {
      const target: any = this.$refs.msg;
      console.log(target);
      target.style.display = "none";

      const ssvg: any = this.$refs.ssvg;
      ssvg.style.visibility = "visible";
      document.body.ontouchstart = null;
    };
  }

  makeImage(data: any, frame: any) {
    var newCanvas: any = this.canvas;

    var ctx = newCanvas.getContext("2d");
    ctx.fillStyle = "red";
    ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);

    ctx.strokeStyle = "#FFFFFF";

    ctx.drawImage(data, 0, 0, 730, 730);
    ctx.drawImage(frame, 40, 40, 205, 277);

    ctx.fillStyle = "rgba(1, 0, 0, 1)";

    ctx.font = "40px BMEULJIRO";
    ctx.save();
    ctx.translate(670, 450);
    ctx.rotate(-0.5 * Math.PI);
    ctx.fillStyle = "red";
    ctx.fillText("greenplay.online", 0, 0);
    ctx.restore();
    /*ctx.font = "40px SingleDay, SDMiSaeng";
    ctx.fillText(this.gameData.date, 40, 615);
    ctx.textAlign = "right";
    ctx.fillText(this.gameData.cc, 657, 663);
    ctx.font = "45px SingleDay, SDMiSaeng";
    ctx.textAlign = "left";
    ctx.fillText(this.gameData.name, 40, 660);*/
  }
  public gameData = {
    ccNum: 0,
    cc: "0cc",
    date: "2021/01/01",
    name: "test",
    playTime: 0,
  };
}
